import React from 'react';

import * as dataService from './dataService';



export interface IProps {
  mode: 'showInAllAccess' | 'hideInAllAccess';
  children: React.ReactNode | React.ReactNode[];
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery();

  if (queryTuple.data.allAccessEnabled && props.mode === 'hideInAllAccess') {
    return null;
  }

  return (
    <>
      {props.children}
    </>
  );
};
